export default __webpack_public_path__ + "static/media/TopL_White.a6b787e4.png";